import { GridColDef } from '@mui/x-data-grid-pro';
import { Account } from 'components/types';
import { useTranslation } from 'react-i18next';

import { dateFormatter, nestedFieldValueGetter } from 'utils/grid';

export const useGetAccountsColumns = (): GridColDef[] => {
  const { t } = useTranslation();

  return [
    { field: 'accountName', flex: 1, headerName: t('accountName') },
    { field: 'nameLast', flex: 1, headerName: t('firstName') },
    { field: 'nameFirst', flex: 1, headerName: t('lastName') },
    { field: 'comEmail', flex: 1, headerName: t('email') },
    {
      field: 'valid.from',
      type: 'date',
      headerName: t('validFrom'),
      valueGetter: (_, row: Account) => nestedFieldValueGetter('valid.from', row),
      valueFormatter: dateFormatter,
      minWidth: 120
    },
    {
      field: 'valid.to',
      type: 'date',
      headerName: t('validTo'),
      valueGetter: (_, row: Account) => nestedFieldValueGetter('valid.to', row),
      valueFormatter: dateFormatter,
      minWidth: 120
    }
  ];
};
